const popupMenu = document.getElementById('popup-menu');

let menuTransition = false;

async function openMenu() {
	if (!popupMenu || menuTransition) return;
	menuTransition = true;

	// resetQuery();
	// updateQuery('menu', 'open', { replace: true });

	document.querySelectorAll('[data-popup=menu]').forEach(cta => {
		cta.classList.add('active');
	});

	popupMenu.hidden = false;

	if (popupCart && !popupCart.hidden) {
		await closeCart();
	} else {
		popupMenu.classList.add('animate-fade-in');
		await new Promise(resolve => setTimeout(resolve, 200));

		popupMenu.removeAttribute('class');
	}

	menuTransition = false;
}

async function closeMenu() {
	if (!popupMenu || menuTransition) return;
	menuTransition = true;

	// deleteQuery('menu', { replace: true });

	document.querySelectorAll('[data-popup=menu]').forEach(cta => {
		cta.classList.remove('active');
	});

	popupMenu.classList.add('animate-fade-out');
	await new Promise(resolve => setTimeout(resolve, 150));

	popupMenu.scrollTo(0, 0);
	popupMenu.removeAttribute('class');
	popupMenu.hidden = true;
	menuTransition = false;
}

// if (window.location.search == '?menu=open') popupMenu.hidden = false;

document.querySelectorAll('[data-popup=menu]').forEach(cta => {
	cta.addEventListener('click', () => {
		popupMenu.hidden ? openMenu() : closeMenu();
	});
});

document.getElementById('popup-menu-header-close').addEventListener('click', () => {
	!popupMenu.hidden && closeMenu();
});

if (!isMobile) {
	document.addEventListener('keyup', e => {
		if (e.key === 'Escape') {
			!popupMenu.hidden && closeMenu();
		}
	});
}
